











































































import { Component, Vue } from 'vue-property-decorator';
import { DbUtile, ResultUser } from "../../database/DbUtile";
import { DbUser, DbUserCourseManagement } from "../../database/DbUser";
import { DbCourseManagementUsersExcelText, DbCourseManagement, DbCourseManagementDetails } from "../../database/DbCourseManagement";
import { AuthUtile } from "../../auth/AuthUtile";

import BackButton from '@/components/BackButton.vue';
import SectionCourseManagement from '@/components/SectionCourseManagement.vue';
import Common from '../../common/Common';
import TsvUtil from '../../common/TsvUtil';
import ValidateStatus from '@/components/ValidateStatus.vue';

@Component({
  components: {
    BackButton,
    SectionCourseManagement,
    ValidateStatus
  }
})
export default class Registration extends Vue {
  private dbUtile = new DbUtile();
  private authUtile = new AuthUtile();

  // 講習 ID
  courseManagementId: string | null = null;
  // 講習詳細
  currentCourseManagement: DbCourseManagement | null = null;

  rows: ResultUser[] = [];

//     // エクセルの 受講者テキスト コピペ
//     private excelText = `申込日時	申込番号	種別	都道府県団体	組織	園（名称）	園（都道府県）	園（市区町村）	職種	氏名（漢字）	氏名（ふりがな）	生年月日	メールアドレス	講義・分科会等1（【選択必修】教育の最新事情）：申込	講義・分科会等1（【選択必修】教育の最新事情）：出席	講義・分科会等1（【選択必修】教育の最新事情）：修了済	講義・分科会等2（【必修】教育の最新事情）：申込	講義・分科会等2（【必修】教育の最新事情）：出席	講義・分科会等2（【必修】教育の最新事情）：修了済	支払	支払合計[円]	支払明細	支払方法	出席	修了済	備考	追加情報：項目1（住所）：郵便番号	追加情報：項目1（住所）：都道府県	追加情報：項目1（住所）：市区町村	追加情報：項目1（住所）：番地以降	追加情報：項目2（電話番号）	追加情報：項目3（職名）	追加情報：項目4（免許状種類）	追加情報：項目5（免許状番号）	追加情報：項目6（免許状有効期間満了日）	免許状更新講習：認定番号1	免許状更新講習：開催地1	免許状更新講習：開催日1	免許状更新講習：受講申込書発送日	免許状更新講習：受講票発送日	免許状更新講習：受講申込書受付日	免許状更新講習：試験得点1	免許状更新講習：試験得点2	免許状更新講習：合否	免許状更新講習：履修認定日	免許状更新講習：履修証明書発送日	免許状更新講習：備考
// 2020/08/17 13:17	2	職員	（一社）福岡県私立幼稚園振興協会	下部組織デモ	学校法人　サンプル学園	福岡県	北九州市若松区	園長	北九 一郎	きたきゅう いちろう	1960/04/20	tfuru27+zetta1@gmail.com	〇			〇			済	12000	参加費 12,000円 × 1名	銀行振込	〇	〇		8080135	福岡県	北九州市若松区	ひびきの	0000000000					平30-80011-508497号	福岡県福岡市	2018/08/17	2020/08/17	2020/08/17	2020/08/17	50	50
//     `;
  // エクセルの 受講者テキスト コピペ
  private excelText = "";

  // 入力チェック
  private validateStatus = {
    error: false,
    message: ""
  };

  created() {
    console.log('created');
    this.authUtile.checkAuthorizedAdmin()
      .then(() => {
        this.courseManagementId = this.$route.params['id'];
        this.getCourseManagementDetails(this.courseManagementId)
          .then(() => {
            this.getUsers()
              .then(() => {
                console.log('users');
              })
              .catch((e) => {
                console.error(e);
              });
          })
          .catch((e) => {
            console.error(e);
          });
        // コピペされ、保存されたテキストを読み出す
        this.getCourseManagementUsersExcelText(this.courseManagementId);
      })
      .catch((e) => {
        console.error('checkAuthorizedAdmin:', e);
        alert(e);
        this.$router.push('/admin/login/');
      });
  }

  getCourseManagementDetails(id: string): Promise<void> {
    return new Promise((resolve,reject) => {
      this.courseManagementId = id;
      this.dbUtile.getCourseManagement(id)
        .then((data: any) => {
          this.currentCourseManagement = data;
          console.log("this.currentCourseManagement", this.currentCourseManagement);
          resolve();
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  }

  getUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dbUtile.getUsersUserCourseManagement(this.courseManagementId!)
        .then((rows: ResultUser[]) => {
          console.log('getUsers rows', rows);
          setTimeout(()=>{
                this.rows = this.sortUsers(rows);
                this.$set(this, "rows", this.rows );
                resolve();
              }, 2000);
        })
        .catch((e: any) => {
            console.error(e);
            reject();
        });
    });
  }

  // 一覧に無いユーザー,履歴を削除する
  deleteUsers(users: DbUser[]){
    // rows 一覧から 登録済み ユーザー を削除する
    const deleteUsers = this.rows.filter((r) => {
      for (const key in users) {
        if ( users[key].email == r.u!.email ){
          return false;
        }
      }
      return true;
    });
    console.log("deleteUsers", deleteUsers);
    // ユーザーを削除する
    deleteUsers.forEach(async (r) => {
      await this.deleteUser(r.id!);
    });
    // 履歴を削除する
    deleteUsers.forEach(async (r) => {
      await this.dbUtile.deleteUserHistory(r.id!, this.courseManagementId!);
    });
  }

  async clickRegistrations(event: any) {
      console.log("clickRegistrations", event.target);

      // 講習申込リスト
      if (Common.isValidate(this.excelText, this.validateStatus, "講習申込リスト は必須入力です") == false){
          console.log('this.validateStatus', this.validateStatus);
          return false;
      }

      // ボタンを押せないように設定
      event.target.classList.add('is-loading');

      // tsvからカラム内のタブと改行を除去
      const parsedTsv = await Common.parseTsv(this.excelText);
      this.excelText = parsedTsv.map(row =>
        row.map(col => col.replaceAll('\t', '').replaceAll('\n', '')).join('\t')
      ).join('\n');
      console.warn(this.excelText);

      // コピペされたデータをDBに登録する
      TsvUtil.parse(this.excelText)
          .then(async (users) => {
              // console.log('users', users);
              if (users.length == 0){
                return;
              }
              // DB に EXCEL コピペ と 変換後の tsv を保存する
              this.addCourseManagementUsersExcelText(this.excelText, TsvUtil.getTsv());

              // 一覧のユーザーを登録
              for (const u of users) await this.addUser(u);
              // 一覧に無いユーザー,履歴を削除する
              this.deleteUsers(users);

              // 一覧を更新
              setTimeout(() => {
                this.getUsers()
                  .then(() => {
                    // currentCourseManagement 受講者数を更新する
                    this.updateCurrentCourseManagement( this.rows.length );

                    console.log('add users success');

                    // ボタンを戻す
                    event.target.classList.remove('is-loading');
                    alert('登録しました');
                  });
              }, 2000);
          })
          .catch((e) => {
              console.error(e);
          });
  }

  // 登録済みメールを送信する
  clickSend() {
    console.log("clickSend");
    // 確認 ダイアログ
    if ( window.confirm("受講者へメールを送信しますが、よろしいですか？") == false) return;

    this.rows.forEach((row) => {
      const email = row.u!.email;
      const name = row.u!.name;
      this.sendCourseManagementEmail(email, name);
    });

    // 送信済みに更新（送信結果は考慮しない）
    this.currentCourseManagement!.sendMailFlag = true;
    this.dbUtile.addCourseManagement(this.courseManagementId!, this.currentCourseManagement!)
      .then((result) => {
        console.log(result);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // 講習 概要が記載された メールをユーザーに送信する
  sendCourseManagementEmail(to: string, name: string) {
    if (this.currentCourseManagement == null){
      return;
    }

    const from = "info@kids-yokohama.or.jp";
    const fromto = (this.currentCourseManagement.from == '') && (this.currentCourseManagement.to == '')
                    ? ''
                    : `${this.currentCourseManagement.from} 〜 ${this.currentCourseManagement.to}`;

    const subject = "【横浜市幼稚園協会 eラーニング『学びトレック』】受講URLのお知らせ";
    const body = `${name} 様

横浜市幼稚園協会が開催する研修会にお申込みいただきましてありがとうございます。
次の詳細をご確認のうえ、期間内に受講完了していただきますよう、よろしくお願い致します。

・講習ID：${this.currentCourseManagement.courseId}
・講習名：${this.currentCourseManagement.name}
・分類：${this.currentCourseManagement.region}
・講師：${this.currentCourseManagement.teacher}
・期間：${fromto}

■学びトレック ログインURL
https://${location.host}/students/login
メールアドレス：${to}
パスワード：設定されたパスワード

☆初めて受講される方☆
上記URLをクリックし、ログイン画面の『パスワード設定』からパスワードの設定を完了してください。
☆パスワード設定済の方☆
上記URLからログインして受講していただけます。
☆パスワードを忘れた場合☆
上記URLをクリックし、ログイン画面の『パスワード設定』からパスワードを再設定してください。

※ご利用可能なブラウザは次の通りです。
　Google Chrome／Microsoft Edge／Safari

こちらのメールについてのお問い合わせは、横浜市幼稚園協会までお願い致します。

－＊－＊－＊－＊－＊－＊－＊－＊－＊－＊－＊－
公益社団法人 横浜市幼稚園協会

〒221-0055横浜市神奈川区大野町1-25
横浜ポートサイドプレイス　アネックス5F
TEL　045-534-8708　　FAX　045-453-1120
Mail　info@kids-yokohama.or.jp
－＊－＊－＊－＊－＊－＊－＊－＊－＊－＊－＊－
`;
    Common.sendMail(from, to, subject, body)
      .then((result) => {
        console.log("result", result);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // DB から ユーザーを削除する
  deleteUser(id: string): Promise<void> {
    console.log("deleteUser", id);
    return new Promise((resolve, reject) => {
      this.dbUtile.deleteUser(this.courseManagementId!, id)
         .then(() => {
           console.log("deleteUser");
           resolve();
         })
        .catch((e: any) => {
            console.error(e);
        });
    });
  }

  // DB に ユーザーを登録する
  addUser(u: DbUser): Promise<void> {
    return new Promise((resolve, reject) => {
        return this.dbUtile.addUser(this.courseManagementId!, u)
          .then((userData: ResultUser) => {
              // ユーザーの講習一覧にも登録する必要がある
              const userCourseManagement = new DbUserCourseManagement();
              userCourseManagement.id = this.courseManagementId!;
              const userId = userData.id!;
              this.dbUtile.addUserCourseManagement(userId, userCourseManagement)
                  .then((rows: any) => {
                    console.log('addUser success', userId);
                    resolve();
                  });
              // 履歴に未受講を追加する
              this.addHistoryManagement(userId, u);
          })
          .catch((e: any) => {
              console.error(e);
          });
    });
  }

  // DB に EXCEL コピペを保存する
  addCourseManagementUsersExcelText(text: string, tsv: string) {
    console.log('addCourseManagementUsersExcelText');
    const usersExcelText: DbCourseManagementUsersExcelText = new DbCourseManagementUsersExcelText();
    usersExcelText.courseId = this.courseManagementId!;
    usersExcelText.text = text;
    usersExcelText.tsv = tsv;
    this.dbUtile.addCourseManagementUsersExcelText(usersExcelText)
        .then(()=> {
            console.log('success');
        })
        .catch((e) => {
            console.error(e);
        });
  }

  // データベースから　EXCEL コピペを読み出す
  getCourseManagementUsersExcelText(courseId: string) {
      this.dbUtile.getCourseManagementUsersExcelText(courseId)
          .then((usersExcelText)=> {
              console.log('success', usersExcelText);
              // this.excelText = usersExcelText.text;
              this.excelText = usersExcelText.tsv;
          })
          .catch((e) => {
              console.error(e);
          });
  }

  // 受講者数を更新
  updateCurrentCourseManagement(cnt: number): Promise<void> {
    console.log('updateCurrentCourseManagement', cnt);
    return new Promise((resolve, reject) => {
      this.currentCourseManagement!.participants = cnt;
      this.dbUtile.addCourseManagement(this.courseManagementId!, this.currentCourseManagement!)
        .then((result) => {
          console.log(result);
          resolve();
        })
        .catch((e) => {
          console.error(e);
          resolve();
        });
    });
  }

  // ソート
  sortUsers(rows: ResultUser[]): ResultUser[] {
    return rows.sort((a,b) => {
      if (a.u!.applicationNumber < b.u!.applicationNumber){
        return -1;
      }
      else if (a.u!.applicationNumber > b.u!.applicationNumber){
        return 1;
      }
      return 0;
    });
  }

  // 履歴を追加する
  addHistoryManagement(userId: string, u: DbUser){
    // ログ登録
    const ucm = new DbUserCourseManagement();
    ucm.id = this.courseManagementId!;
    ucm.status = DbUserCourseManagement.STATUS.NotAttended;

    // 履歴を追加する
    this.dbUtile.addHistoryManagement(userId, u, this.courseManagementId!, ucm)
      .then(() => {
        console.log("addHistoryManagement success");
      })
      .catch((e) => {
        console.error(e);
      });

    // 履歴詳細 を 追加する
    this.dbUtile.addHistoryManagementDetails(userId, u, ucm, this.courseManagementId!)
      .then(() => {
        console.log("addHistoryManagementDetails success");
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
